import { defineStore } from 'pinia'
import { useShopsStore } from '@/stores/Shops.store'
import { getShop, getDeliveryDates } from '@/api/api'

export const useScanOrderStore = defineStore('scanOrder', {
  state: () => ({
    orderDetails: {
      instruction: '',
      pickUpAddress: {},
      deliveryAddress: {},
      invoiceAddress: {},
      deliveryDate: {},
      pickUpDate: {},
      quotationNo: '',
      medium: {
        isArchive: false,
        isDisk: false,
        isEmail: false,
        isOther: false,
        emailAddress: ''
      },
      project: {
        id: 0,
        name: ''
      },
      reference: '',
      externalId: '',
      orderType: 'scanOrder'
    },
    shop: {},
    deliveryDates: [],
    pickUpDates: [],
    orderErrors: []
  }),
  actions: {
    resetOrder() {
      this.orderDetails = {
        instruction: '',
        pickUpAddress: {},
        deliveryAddress: {},
        invoiceAddress: {},
        deliveryDate: {},
        pickUpDate: {},
        quotationNo: '',
        medium: {
          isArchive: false,
          isDisk: false,
          isEmail: false,
          isOther: false,
          emailAddress: ''
        },
        project: {
          id: 0,
          name: ''
        },
        reference: '',
        externalId: '',
        orderType: 'scanOrder'
      }
      this.shop = {}
      this.deliveryDates = []
      this.pickUpDates = []
      this.orderErrors = []
    },
    addOrderError(error) {
      if (this.orderErrors.indexOf(error) < 0) {
        this.orderErrors.push(error)
      }
    },
    removeOrderError(error) {
      this.orderErrors = this.orderErrors.filter((e) => e !== error)
    },
    updateOrderDetails(spec, value) {
      this.orderDetails[spec] = value
    },
    updateProject(proj) {
      this.orderDetails.project.name = proj.name || ''
      this.orderDetails.project.id = proj.id || 0
    },
    updateShop(shop) {
      this.shop = shop
    },
    updatePickUpDates(dates) {
      this.pickUpDates = dates
    },
    updateDeliveryDates(dates) {
      this.deliveryDates = dates
    },
    getThePickUpDates(val) {
      return new Promise((resolve, reject) => {
        getDeliveryDates(val.shopId, val.invoiceId, val.secure).then((resp) => {
          this.updatePickUpDates(resp)
          resolve(resp)
        })
      })
    },
    getTheDeliveryDates(val) {
      return new Promise((resolve, reject) => {
        getDeliveryDates(
          val.shopId,
          val.invoiceId,
          val.secure,
          val.offset
        ).then((resp) => {
          this.updateDeliveryDates(resp)
          resolve(resp)
        })
      })
    },
    getTheShop(val) {
      getShop(val.deliveryAddress, val.invoiceId, val.secure).then((resp) => {
        const shopsStore = useShopsStore()
        const shop =
          shopsStore.shopsList.find((shop) => {
            return resp.location.id === shop.id
          }) || {}
        this.updateShop(shop)
      })
    }
  },
  getters: {}
})
